import Icon, { CloseOutlined } from '@ant-design/icons';
import { FloatButton, Popover } from 'antd';
import { useEffect, useState } from 'react';
import { useChatbot } from "../contexts/ChatContext";
import { useEventAction } from "../contexts/EventContext";
import Chatbot from './Chatbot';

import style from "./ChatbotPopover.module.css";

const BotSvg = () => (
    <svg width="16pt" height="16pt" viewBox="0 0 512 512">
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path d="M1559 5102 c-202 -67 -313 -279 -251 -480 33 -103 99 -180 200 -231 l43 -22 -3 -137 -3 -137 -265 -6 c-239 -5 -271 -7 -323 -27 -196 -72 -349 -233 -413 -432 -14 -44 -18 -104 -22 -306 l-4 -252 -111 -4 c-93 -4 -122 -9 -170 -31 -79 -36 -167 -126 -198 -204 -23 -56 -24 -69 -27 -384 -3 -311 -2 -330 18 -389 39 -116 98 -181 209 -233 56 -27 79 -31 172 -35 l108 -5 3 -311 c4 -308 4 -312 31 -393 65 -193 209 -338 409 -411 l73 -27 383 -3 382 -3 0 -265 c0 -295 4 -318 62 -354 67 -43 71 -41 622 304 l506 316 525 0 c446 0 537 2 598 16 184 41 342 163 431 334 64 121 68 152 73 493 l5 307 73 0 c189 0 321 73 392 218 l28 57 0 370 0 370 -24 45 c-80 152 -199 220 -382 220 l-89 0 0 198 c0 299 -21 400 -109 534 -80 122 -192 210 -331 259 -60 22 -86 24 -325 29 l-260 5 -3 136 -3 137 56 31 c273 154 268 540 -8 676 -130 64 -262 57 -382 -19 -65 -42 -100 -84 -139 -166 -27 -58 -31 -75 -31 -155 0 -80 4 -97 32 -157 37 -79 101 -147 172 -183 l52 -26 -3 -137 -3 -137 -765 0 -765 0 -3 140 -3 141 36 13 c52 18 150 114 180 175 122 250 -45 537 -323 552 -57 3 -91 -1 -133 -14z m204 -281 c28 -28 32 -38 32 -87 0 -51 -3 -58 -37 -90 -30 -27 -46 -34 -78 -34 -79 0 -130 49 -130 125 0 81 52 128 133 122 39 -3 56 -11 80 -36z m1788 0 c33 -33 39 -45 39 -81 0 -101 -100 -162 -190 -115 -79 41 -80 170 -1 218 14 9 46 17 70 17 37 0 49 -5 82 -39z m591 -1024 c114 -56 182 -143 208 -265 7 -30 10 -450 8 -1197 l-3 -1150 -27 -57 c-35 -76 -109 -153 -183 -192 l-60 -31 -585 -5 -585 -5 -425 -266 -425 -265 -5 221 c-5 240 -9 254 -67 292 -25 16 -69 18 -483 23 l-455 5 -58 28 c-74 37 -147 110 -184 184 l-28 58 0 1190 0 1190 26 56 c32 68 84 127 147 168 99 63 12 60 1633 58 l1475 -2 76 -38z m-3622 -1362 l0 -385 -82 0 c-90 0 -129 16 -154 62 -20 36 -19 599 0 637 27 52 65 67 174 70 l62 1 0 -385z m4286 362 c63 -33 66 -49 62 -380 l-3 -299 -37 -34 c-37 -33 -40 -34 -123 -34 l-85 0 0 386 0 387 78 -5 c42 -3 91 -12 108 -21z" />
            <path d="M1845 3316 c-117 -29 -206 -99 -257 -204 -27 -54 -34 -81 -36 -143 -4 -76 -4 -76 32 -113 31 -31 43 -36 82 -36 25 0 59 8 75 17 31 18 59 67 59 102 0 67 62 131 128 131 69 0 116 -45 128 -122 14 -87 55 -128 129 -128 88 0 130 55 123 161 -12 163 -139 303 -306 338 -65 13 -92 13 -157 -3z" />
            <path d="M3125 3316 c-72 -18 -119 -43 -174 -92 -60 -54 -109 -144 -119 -220 -11 -79 0 -123 37 -156 25 -23 41 -28 81 -28 70 0 116 42 130 118 12 68 24 89 63 112 57 35 135 20 170 -34 9 -13 20 -44 23 -68 14 -87 55 -128 129 -128 88 0 130 55 123 159 -12 164 -139 305 -306 340 -65 13 -92 13 -157 -3z" />
            <path d="M1608 1964 c-54 -29 -74 -113 -42 -176 36 -69 379 -188 679 -234 152 -23 499 -23 650 0 283 44 607 153 668 225 65 78 7 201 -95 201 -19 0 -77 -18 -128 -41 -179 -77 -379 -123 -617 -141 -321 -25 -659 27 -925 142 -99 42 -146 49 -190 24z" />
        </g>
    </svg>
);

const BotIcon = (props) => <Icon component={BotSvg} {...props} />;

const ChatbotPopover = ({ learningJourneyId, view }) => {
    const { open, setOpen } = useChatbot();
    const [unreadMessages, setUnreadMessages] = useState(0);

    useEventAction("bot-notification", () => {
        setUnreadMessages(prev => prev + 1);
    });

    // Reset the unread badge whenever the popover opens, regardless of whether
    // the open was triggered by the user clicking the button or by the backend
    // requesting it via view.chat.open.
    useEffect(() => {
        if (open) setUnreadMessages(0);
    }, [open]);

    return (
        <Popover
            trigger="click"
            open={open}
            onOpenChange={setOpen}
            content={
                <div className={style.chatbotPopoverContent}>
                    <div className={style.chatbotHeader}>
                        <CloseOutlined
                            className={style.closeIcon}
                            onClick={() => setOpen(false)}
                        />
                    </div>

                    <div className={style.chatbotBody}>
                        <Chatbot
                            learningJourneyId={learningJourneyId}
                            view={view}
                        />
                    </div>
                </div>
            }>
            <FloatButton
                className="chatbotPopover"
                aria-label="Open chat"
                icon={<BotIcon />}
                badge={{ count: unreadMessages, color: 'var(--brand)' }}
            />
        </Popover>
    )
};

export default ChatbotPopover;